
/*
 * ACTIONS
 */

export const PASSWORD_SET_REQUEST = 'PasswordSet/PASSWORD_SET_REQUEST';
export const PASSWORD_SET_SUCCESS = 'PasswordSet/PASSWORD_SET_SUCCESS';
export const PASSWORD_SET_ERROR   = 'PasswordSet/PASSWORD_SET_ERROR';
